import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '@/components/Home';
import SubdepList from '@/components/SubdepList';
import PoiList from '@/components/PoiList';
import UiList from '@/components/UiList';
import Ui from '@/components/Ui';
import Auth from '@/components/Auth';
import Login from '@/components/Login';
import DashboardDaee from '@/components/DashboardDaee';
import ChangeInstance from '@/components/ChangeInstance';

Vue.use(VueRouter);

const routes = [
    {
        name: "Home",
        path: "/",
        component: Home
    },
    {
        name: "SubdepList",
        path: "/subdepList/:gotoMain?",
        component: SubdepList
    },
    {
        name: "PoiList",
        path: "/poiList/:subdepId",
        component: PoiList
    },
    {
        name: 'UiList',
        path: '/uiList/:poiId',
        component: UiList
    },
    {
        name: 'Ui',
        path: '/ui/:id',
        component: Ui
    },
    {
        name: 'Auth',
        path: '/auth/:token',
        component: Auth
    },
    {
        name: 'Login',
        path: '/login/:restoreInstanceList?',
        component: Login
    },
    {
        name: 'DashboardDaee',
        path: '/DashboardDaee',
        component: DashboardDaee
    },
    {
        name: 'ChangeInstance',
        path: '/ChangeInstance',
        component: ChangeInstance
    }
];

// eslint-disable-next-line no-new
const router = new VueRouter({
    routes
});

export default router
